(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["home-collection-gift"] && !window.DesignMode) return;
  try {
    
 $(document).ready(function(){
   $("#school ,.school").addClass("active");
   $("#school").click(function(){
     $(".click-a, .click-text").removeClass("active");
     $("#school ,.school").addClass("active");
   })
   $("#bags").click(function(){
     $(".click-a, .click-text").removeClass("active");
     $("#bags ,.bags").addClass("active");
   })
   $("#beauty").click(function(){
     $(".click-a, .click-text").removeClass("active");
     $("#beauty ,.beauty").addClass("active");
   })
   $("#travel").click(function(){
     $(".click-a, .click-text").removeClass("active");
     $("#travel ,.travel").addClass("active");
   })
 })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-image-home"] && !window.DesignMode) return;
  try {
    
    var swiper = new Swiper(".mySwiper", {
	          slidesPerView: 3,
	          spaceBetween: 0,
			  
				 navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
				 breakpoints: { 
			        320: {  
			          slidesPerView: 1
			        },
			        500: {
			          slidesPerView: 3
			        }
			        
			      }
	        });
			

  } catch(e) { console.error(e); }
})();

})();
